import { Checkbox } from 'antd';
import React from 'react';
import { Typography } from 'tfc-components';

import { IPackage, PackageOption } from '.';

import Loading from 'components/atoms/Loading';

interface PackageSelectorProps {
  mainPackages: PackageOption[];
  duration: 'monthly' | 'yearly';
  selectedAddons: IPackage[];
  isAddonPackageLoading: boolean;
  currentMainPackage: { id: number, name: string, duration: number, price: number }
  selectPackage: (data: IPackage) => void
}

const PackageSelector: React.FC<PackageSelectorProps> = ({
  duration,
  selectedAddons,
  mainPackages,
  isAddonPackageLoading,
  currentMainPackage,
  selectPackage
}) => {
  const addOnPackages = mainPackages.find(
    (pkg) => pkg.id === currentMainPackage?.id
  )?.servicePackageAddOnData || [];

  const toggleAddon = (addOn: IPackage) => {
    selectPackage(addOn);
  };

  return (
    <div>
      <div className="p-checkout_durationTabs">
        <Typography.Text fontweight="600" extendClasses="p-checkout_titleProduct fs-20x24">Select a Add-on package</Typography.Text>
        <div className="p-checkout_addonPackage">
          <div className="p-checkout_mainPackage_title">
            <Typography.Text fontweight="600" extendClasses="p-checkout_mainPackage_titleText fs-16x20">Add-on package</Typography.Text>
            <div className="p-checkout_mainPackage_titleDivider" />
          </div>
          {isAddonPackageLoading ? <div className="p-checkout_mainPackage"><Loading /></div> : (
            <div className="p-checkout_grid">
              {addOnPackages.length > 0 ? addOnPackages.map((pkg) => (
                <div
                  key={pkg.id}
                  className={`p-checkout_packageCard p-checkout_packageCard_addon${selectedAddons.some((a) => a.packageId === `${pkg.id}`)
                    ? 'Selected' : ''}`}
                  onClick={() => toggleAddon({
                    id: `${pkg.id}`,
                    name: pkg.name,
                    price: pkg.price,
                    quantity: 1,
                    duration: 1,
                    latestTier: {
                      numberOfAgent: pkg.numberOfAgent,
                      numberOfFile: pkg.numberOfFile,
                      numberOfSession: pkg.numberOfSession,
                      numberOfWebsite: pkg.numberOfWebsite,
                      totalSizeLimit: pkg.totalSizeLimit
                    }
                  })}
                >
                  <div className="p-checkout_packageCard_addOnInfo">
                    <div>
                      <Typography.Text fontweight="600" extendClasses="p-checkout_packageCard_name fs-18x21">{pkg.name}</Typography.Text>
                      <div className="p-checkout_packageCard_price">
                        <Typography.Text fontweight="600" extendClasses="p-checkout_packageCard_amount fs-18x21">
                          {pkg.price.toLocaleString('vi')}
                          {' '}
                          VND
                        </Typography.Text>
                        <span className="p-checkout_packageCard_duration">
                          /
                          {duration === 'monthly' ? 'month' : 'year'}
                        </span>
                      </div>
                    </div>
                    <Checkbox
                      type="checkbox"
                      checked={selectedAddons.some((a) => a.packageId === `${pkg.id}`)}
                      className="p-monitorDashboard_filter_optionCheckbox"
                    // onChange={() => toggleAddon({
                    //   id: `${pkg.id}`,
                    //   name: pkg.name,
                    //   price: pkg.price,
                    //   quantity: 1,
                    //   duration: 1,
                    //   latestTier: {
                    //     numberOfAgent: pkg.numberOfAgent,
                    //     numberOfFile: pkg.numberOfFile,
                    //     numberOfSession: pkg.numberOfSession,
                    //     numberOfWebsite: pkg.numberOfWebsite,
                    //     totalSizeLimit: pkg.totalSizeLimit
                    //   }
                    // })}
                    />
                  </div>
                  {pkg.description && (
                    <div className="p-checkout_packageCard_hover">
                      <Typography.Text extendClasses="fs-14x18">
                        {pkg.description}
                      </Typography.Text>
                    </div>
                  )}
                </div>
              ))
                : (
                  <div className="p-checkout_packageCard_empty">
                    <Typography.Text fontweight="600" extendClasses="p-checkout_packageCard_name">No Available Package</Typography.Text>
                  </div>
                )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PackageSelector;
